<template>
  <div class="date-window">
    <label class="date-window-label">
      <slot name="label"></slot>
    </label>
    <template v-for="(window, index) in value">
      <div :key="'window_' + index" class="dates">
        <date-range-picker
          :start="window.key"
          :end="window.value"
          :display-from-to="true"
          @change="setDateOnIndex($event, index)"
          ref="picker"
          :style="customStyle"
          :apply-limit-days="applyLimitDays"
        >
        </date-range-picker>

        <md-button v-if="!$props.fixedLength && Math.max(1, value.length) > 1" @click="deleteWindow(index)" class="md-white md-just-icon"
          ><md-icon>delete</md-icon></md-button
        >
        <md-button v-if="!$props.fixedLength && index + 1 == Math.max(1, value.length)" @click="addWindow" class="md-white md-just-icon"
          ><md-icon>add</md-icon></md-button
        >
      </div>
    </template>
  </div>
</template>

<script>
import DateRangePicker from '@/components/Inputs/DateRangePicker.vue'

export default {
  name: 'DateWindow',
  props: {
    value: Array,
    fixedLength: Boolean,
    mdClearable: {
      type: Boolean,
      default: true,
    },
    applyLimitDays: Boolean,
  },
  components: {
    DateRangePicker,
  },
  methods: {
    setDateOnIndex($event, index) {
      this.$set(this.value, index, {
        key: $event.start,
        value: $event.end,
      })
    },
    addWindow() {
      this.value.push({
        key: null,
        value: null,
      })
    },
    deleteWindow(index) {
      this.$delete(this.value, index)
      this.$refs['picker'].forEach((r) => {
        r.refresh()
      })
    },
  },
  mounted() {
    if (this.value && !this.value.length) this.addWindow()
  },
  computed: {
    customStyle() {
      return this.$props.fixedLength ? 'width: 100%' : 'width: calc(100% - 82px)'
    },
  },
}
</script>

<style lang="scss">
@import 'src/assets/scss/md/_variables.scss';

.date-window {
  margin-top: 13px;
  position: relative;
  min-width: 300px;

  .md-field.md-datepicker {
    width: 40%;
  }

  .date-window-label {
    position: absolute;
    top: -1.1rem;
    font-size: 0.6875rem;
    color: $mdb-input-placeholder-color !important;
    font-weight: 400;
  }

  .dates {
    display: flex;
    align-items: center;
    > span {
      width: 100%;
    }
  }
}
.splitter {
  margin: 0 15px;
}
</style>
